import { getTheme } from "components/theme/theme";
import moment from "moment";
import React from "react";
import { useLocalStorage } from "utilities/usehooks";

interface Props {
  visibleFrom: moment.Moment;
  visibleUntil: moment.Moment;
  imageUrlDark: string;
  imageUrlLight: string;
  id: string;
}

export const NewFeatureAddSidebar = (props: Props) => {
  const theme = getTheme();
  const currentTime = moment.utc();
  const isVisible = currentTime.isAfter(props.visibleFrom) && currentTime.isBefore(props.visibleUntil);
  const [_, setVisible] = useLocalStorage(`announcement:${props.id}`, true);

  if (!isVisible) {
    return null;
  }

  const imageUrl = theme === "dark" ? props.imageUrlDark : props.imageUrlLight;

  return <div onClick={() => setVisible(true)} className="new-feature-add-sidebar-wrapper">
    <img src={imageUrl} className="new-feature-add-sidebar-image" />
  </div>
}